// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
import VueScrollTo from 'vue-scrollto'
import Scrollspy from 'vue2-scrollspy'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta'
import VueAnalytics from 'vue-analytics'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import { ContainerSmall, BackgroundWrapper, TextContainer, BackgroundWrapperContain, BackgroundWrapperMd } from '@/components/ui'
import './app.sass'
import { messages } from './translations'
const defaultLocale = Object.keys(messages)[0]

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// Vue Internationalization
Vue.use(VueI18n)

Vue.use(VueScrollTo)
Vue.use(Scrollspy)
Vue.use(VueAxios, axios)
Vue.use(VueMeta)
Vue.use(VueAnalytics, {
  id: 'UA-21781667-1'
})

Vue.config.productionTip = false

Vue.prototype.$toKebabCase = string => string.replace(/([A-Z])([A-Z])/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase()
Vue.prototype.$cmsDomain = process.env['CMS_DOMAIN']
Vue.component('ContainerSmall', ContainerSmall)
Vue.component('BackgroundWrapper', BackgroundWrapper)
Vue.component('BackgroundWrapperMd', BackgroundWrapperMd)
Vue.component('BackgroundWrapperContain', BackgroundWrapperContain)
Vue.component('TextContainer', TextContainer)

const i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js